import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initGA = () => {
  if (GA_MEASUREMENT_ID) {
    // Check cookie consent status
    const cookieConsent = localStorage.getItem('cookieConsent');

    ReactGA.initialize(GA_MEASUREMENT_ID, {
      gaOptions: {
        anonymizeIp: true, // GDPR compliance
        // Start with denied consent by default
        'storage': cookieConsent === 'accepted' ? 'granted' : 'denied',
      },
    });

    // Set initial consent state
    if (window.gtag) {
      window.gtag('consent', 'default', {
        'analytics_storage': cookieConsent === 'accepted' ? 'granted' : 'denied'
      });
    }
  }
};

export const logPageView = (path) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

export const logEvent = (category, action, label = null, value = null) => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

// Specific event tracking functions
export const trackContactFormSubmit = (formData) => {
  logEvent('Contact', 'form_submit', 'contact_form');
};

export const trackRequestAccess = () => {
  logEvent('CTA', 'click', 'request_access');
};

export const trackLanguageChange = (language) => {
  logEvent('User Preference', 'language_change', language);
};

export const trackNavigation = (section) => {
  logEvent('Navigation', 'click', section);
};

export const trackOpenApp = () => {
  logEvent('CTA', 'click', 'open_app');
};

export const trackVideoPlay = () => {
  logEvent('Engagement', 'video_play', 'demo_video');
};

export const trackFAQInteraction = (question) => {
  logEvent('Engagement', 'faq_expand', question);
};

export const trackPricingPlanClick = (planName) => {
  logEvent('Pricing', 'plan_click', planName);
};

export const trackContactSales = () => {
  logEvent('CTA', 'click', 'contact_sales');
};

export const trackViewCoverage = (source) => {
  logEvent('Navigation', 'view_coverage', source);
};

export const trackExternalLink = (url) => {
  logEvent('Outbound', 'click', url);
};

export const trackScrollDepth = (percentage) => {
  logEvent('Engagement', 'scroll_depth', `${percentage}%`);
};
